import { getCurrentLanguageSetting } from 'Helpers/language-setting';
import { isEmpty, isNil, omitBy } from 'lodash';
import { InventoryTranslationType } from 'src/models/inventory-translation';

/**
 * @see https://stackoverflow.com/a/56051256
 * @param s 
 */
function getParsedHTML(s: string) {
  if (isNil(s)) return '';

  if (!s) return '';
  if (!s.trim()) return '';

  const aux = document.createElement('div');
  aux.innerHTML = s;
  const trimmedContent = aux.innerText.trim();
  return trimmedContent;
}


/**
 * Note: will mutate the data
 * 
 * @param data 
 * @returns 
 */
const response = (data: any) => {
  const languageSetting = getCurrentLanguageSetting();
  const availableTranslations: InventoryTranslationType[] = data?.product?.translations ?? [];
  const foundTranslationObject = availableTranslations.find((a) => a.language === languageSetting);
  if (foundTranslationObject) {
    if (data.ecomData) {
      data.ecomData = omitBy(
        {
          ...data.ecomData,
          ecomDetails:
            getParsedHTML(foundTranslationObject.productTranslation.ecomDetails) || data.ecomData.ecomDetails,
          specification:
            getParsedHTML(foundTranslationObject.productTranslation.specification) || data.ecomData.specification,
          disclaimer:
            getParsedHTML(foundTranslationObject.productTranslation.disclaimer) || data.ecomData.disclaimer,
          about: getParsedHTML(foundTranslationObject.productTranslation.about) || data.ecomData.about,
          precautions:
            getParsedHTML(foundTranslationObject.productTranslation.precautions) || data.ecomData.precautions,
          sideEffects:
            getParsedHTML(foundTranslationObject.productTranslation.sideEffects) || data.ecomData.sideEffects,
          overviews: getParsedHTML(foundTranslationObject.productTranslation.overviews) || data.ecomData.overviews,
          faqs: getParsedHTML(foundTranslationObject.productTranslation.faqs) || data.ecomData.faqs,
        },
        isNil,
      );
    }

    // treat images differently
    const hasImagesInThisTranslation = !isEmpty(foundTranslationObject.productTranslation.images);
    const newImages = hasImagesInThisTranslation
      ? // keep the images with variantCode, as we don't have translations for variants
        data.product.images.filter((p) => p.variantCode || p.language === languageSetting)
      : data.product.images;

    data.product = {
      ...data.product,
      description: getParsedHTML(foundTranslationObject.productTranslation.description) || data.product.description,
      name: foundTranslationObject.productTranslation.name ?? data.product.name,
      images: newImages,
    };
  } else {
    // remove images that is for translations only
    const newImages = (data.product.images ?? []).filter((p) => !p.language);
    data.product = {
      ...data.product,
      images: newImages,
    };
  }

  return data;
};

export default response;
